module.exports = "/static/assets/c74353e50fadca255bf39786b9ab0b0c.svg";